import React from "react";
import Button from "@streeteasy/design-system/deprecated/Button";
import { Formik } from "formik";
import { bool, func, oneOf, shape, string } from "prop-types";

import ENTITY_TYPES from "../../constants/entityTypes";
import INQUIRY_TYPES from "../../constants/inquiryTypes";
import { interestedSellerInquiryFormSchema } from "../../schemas/interestedSellerInquiry";
import formText from "../../utilities/formText";
import formTitle from "../../utilities/formTitle";
import * as S from "./styled";

const InterestedSellerForm = ({
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  className,
  entityType,
  handleFormSubmit,
  initialFormValues,
  inquiryType
}) => (
  <S.Content className={className}>
    <S.FormTitle id={ariaContentLabelledBy}>
      {formTitle(inquiryType)}
    </S.FormTitle>
    <S.FormText id={ariaContentDescribedBy}>
      {formText(inquiryType, entityType)}
    </S.FormText>
    <Formik
      initialValues={initialFormValues}
      onSubmit={(values, { setSubmitting }) => {
        handleFormSubmit(values, {
          onError: () => setSubmitting(false)
        });
      }}
      validationSchema={interestedSellerInquiryFormSchema}
    >
      {({
        errors,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values
      }) => (
        <form onSubmit={handleSubmit}>
          <S.Label htmlFor="name">
            Name
            <S.FormTextInput
              id="name"
              isInvalid={touched.name && !!errors.name}
              name="name"
              onChange={(_, event) => handleChange(event)}
              value={values.name}
            />
            {touched.name && !!errors.name && (
              <S.ErrorText>{errors.name}</S.ErrorText>
            )}
          </S.Label>
          <S.Label htmlFor="phone_number">
            Phone Number
            <S.FormTextInput
              id="phone_number"
              isInvalid={touched.phone_number && !!errors.phone_number}
              name="phone_number"
              onChange={(_, event) => handleChange(event)}
              value={values.phone_number}
            />
            {touched.phone_number && !!errors.phone_number && (
              <S.ErrorText>{errors.phone_number}</S.ErrorText>
            )}
          </S.Label>
          <S.Label htmlFor="email">
            Email
            <S.FormTextInput
              id="email"
              isInvalid={touched.email && !!errors.email}
              name="email"
              onChange={(_, event) => handleChange(event)}
              type="email"
              value={values.email}
            />
            {touched.email && !!errors.email && (
              <S.ErrorText>{errors.email}</S.ErrorText>
            )}
          </S.Label>
          <S.Label htmlFor="notes">
            Notes (optional)
            <S.FormTextArea
              id="notes"
              name="notes"
              onChange={(_, event) => handleChange(event)}
            />
          </S.Label>
          <S.ContactPreferences>
            <S.ContactPreferencesTitle>
              Your Contact Preferences
            </S.ContactPreferencesTitle>
            <S.ContactPreferencesFields>
              <S.ContactPreferencesCheckbox
                isChecked={values.contact_preferences.email}
                isInvalid={
                  touched.contact_preferences && !!errors.contact_preferences
                }
                label="Email"
                name="contact_preferences.email"
                onChange={(_, event) => handleChange(event)}
                theme="primary"
              />
              <S.ContactPreferencesCheckbox
                isInvalid={
                  touched.contact_preferences && !!errors.contact_preferences
                }
                label="Call"
                name="contact_preferences.call"
                onChange={(_, event) => handleChange(event)}
                theme="primary"
              />
              <S.ContactPreferencesCheckbox
                isInvalid={
                  touched.contact_preferences && !!errors.contact_preferences
                }
                label="Text"
                name="contact_preferences.text"
                onChange={(_, event) => handleChange(event)}
                theme="primary"
              />
            </S.ContactPreferencesFields>
            {touched.contact_preferences && !!errors.contact_preferences && (
              <S.ContactPreferencesError>
                {errors.contact_preferences}
              </S.ContactPreferencesError>
            )}
          </S.ContactPreferences>
          <S.Spacer />
          <Button disabled={isSubmitting} theme="primary" type="submit">
            Submit
          </Button>
        </form>
      )}
    </Formik>
    <S.TermsAndConditionsContainer>
      <S.DisclaimerText>
        I accept StreetEasy&apos;s{" "}
        <S.TermsAndConditionsLink
          href="https://www.zillow.com/corp/Terms.htm"
          target="_blank"
        >
          Terms of Use
        </S.TermsAndConditionsLink>
      </S.DisclaimerText>
    </S.TermsAndConditionsContainer>
  </S.Content>
);

InterestedSellerForm.defaultProps = {
  className: "",
  entityType: ENTITY_TYPES.sale
};

InterestedSellerForm.propTypes = {
  ariaContentDescribedBy: string.isRequired,
  ariaContentLabelledBy: string.isRequired,
  className: string,
  entityType: oneOf(Object.values(ENTITY_TYPES)),
  handleFormSubmit: func.isRequired,
  initialFormValues: shape({
    name: string,
    email: string,
    phone_number: string,
    notes: string,
    contact_preferences: shape({
      email: bool,
      call: bool,
      text: bool
    })
  }).isRequired,
  inquiryType: oneOf(Object.values(INQUIRY_TYPES)).isRequired
};

export default InterestedSellerForm;
